var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"air3DModel"},[_vm._v("3D控制模型")])
}
var staticRenderFns = []

export { render, staticRenderFns }